import logger from 'itrvl-logger';
import window from 'common/utils/window-or-global';

// Setup logger
logger.setup(false, true);
window.logger = logger;

require('./bootstrap');
